import type { LandmarkId, NpcId } from "./catalog";

const KEY = "planet-web.collection.v1";

export type SaveState = {
  postcards: LandmarkId[];
  badges: NpcId[];
  muted: boolean;
};

const LANDMARK_IDS: LandmarkId[] = ["workshop", "lighthouse", "garden"];
const NPC_IDS: NpcId[] = [
  "flame",
  "robot",
  "drop",
  "butterfly",
  "hedgehog",
  "balloon",
  "fox",
  "snail",
];

function isLandmarkId(value: unknown): value is LandmarkId {
  return typeof value === "string" && (LANDMARK_IDS as string[]).includes(value);
}

function isNpcId(value: unknown): value is NpcId {
  return typeof value === "string" && (NPC_IDS as string[]).includes(value);
}

export function emptySave(): SaveState {
  return { postcards: [], badges: [], muted: false };
}

export function loadSave(): SaveState {
  try {
    const raw = localStorage.getItem(KEY);
    if (!raw) {
      return emptySave();
    }
    const parsed = JSON.parse(raw) as Partial<SaveState>;
    return {
      postcards: Array.isArray(parsed.postcards) ? parsed.postcards.filter(isLandmarkId) : [],
      badges: Array.isArray(parsed.badges) ? parsed.badges.filter(isNpcId) : [],
      muted: Boolean(parsed.muted),
    };
  } catch {
    return emptySave();
  }
}

export function writeSave(state: SaveState): void {
  localStorage.setItem(KEY, JSON.stringify(state));
}

export function unlockPostcard(state: SaveState, id: LandmarkId): boolean {
  if (state.postcards.includes(id)) {
    return false;
  }
  state.postcards = [...state.postcards, id];
  writeSave(state);
  return true;
}

export function unlockBadge(state: SaveState, id: NpcId): boolean {
  if (state.badges.includes(id)) {
    return false;
  }
  state.badges = [...state.badges, id];
  writeSave(state);
  return true;
}

export function setMuted(state: SaveState, muted: boolean): void {
  state.muted = muted;
  writeSave(state);
}
